<template>
    <div class="animated fadeIn webAnalysis">

        <filters :scope="filtersScope">
        </filters>

        <div class="filters__atalytics">
            <div class="filters__atalytics--title card-header">
                <i aria-hidden="true" class="fa fa-filter"></i>
                Фильтры по анализу
            </div>
            <div class="filters__atalytics--content">
                <div>
                    <label for="aprove">
                        <input type="radio" id="aprove" value="aprove" v-model="picked" @change="onChancgeSelect">
                        По выкупам</label>
                    <label for="buyout">
                        <input type="radio" id="buyout" value="buyout" v-model="picked" @change="onChancgeSelect">
                        По апрувам</label>
                </div>
                <div class="content__percent">
                    <label for="percent">
                        <input type="number" id="percent" v-model="percent" @change="getPercent">
                        Процентное значение: {{ percent}}%</label>
                </div>
            </div>
        </div>

        <WebTabs></WebTabs>

        <div class="container__table excel" style="overflow:hidden; width:100%">
            <div id="swipe" v-hammer:pan="onSwipe" style="display:flex;flex-wrap: nowrap; width: 100%;" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}">
                <StatisticTable :footColumns="firstFootColumns"
                                :headColumns="headColumns"
                                :rows="rows_first"
                                title="Первый период"
                                :isExelAll="true"
                                :isFlypostModal="true"
                                :copy-icon="'webmaster'"
                                @copy="copyWebmasters(rows_first)"
                                @exportingAll="exportingAll"
                >
                </StatisticTable>
                <StatisticTable :footColumns="secondFootColumns"
                                :headColumns="headColumns"
                                :isFlypostModal="true"
                                :rows="rows_second"
                                :copy-icon="'webmaster'"
                                @copy="copyWebmasters(rows_second)"
                                title="Второй период"
                >
                </StatisticTable>
                <StatisticTable
                        :footColumns="differenceFootColumns"
                        :headColumns="headColumnsDifference"
                        :rows="rows_difference"
                        :isFlypostModal="true"
                        :copy-icon="'webmaster'"
                        @copy="copyWebmasters(rows_difference)"
                        title="Разница"
                        id="table_difference"
                        class="table_difference"
                >
                </StatisticTable>
                <StatisticTable
                        :footColumns="differenceFootColumns"
                        :headColumns="headColumnsDifference"
                        :rows="rows_difference_aprove"
                        :isFlypostModal="true"
                        :copy-icon="'webmaster'"
                        @copy="copyWebmasters(rows_difference_aprove)"
                        title="Разница по апрувам"
                        id="table_difference_aprove"
                        class="table_difference_aprove noActive"
                >
                </StatisticTable>
                <StatisticTable
                        :footColumns="lastFootColumns"
                        :headColumns="headColumnsLst"
                        :isFlypostModal="true"
                        :rows="rows_last"
                        :copy-icon="'webmaster'"
                        @copy="copyWebmasters(rows_last)"
                        title="Последняя неделя"
                >
                </StatisticTable>
            </div>
        </div>


        <div class="content__table_difference_web excel">
            <StatisticTable
                    :footColumns="differenceFootColumnsWeb"
                    :headColumns="headColumnsLstWeb"
                    :rows="rows_difference_web"
                    :isFlypostModal="true"
                    :copy-icon="'webmaster'"
                    @copy="copyWebmasters(rows_difference_web)"
                    title="Вебмастера имеющие -% по выкупам"
                    id="table_difference_web"
                    class="table_difference_web"
            >
            </StatisticTable>
            <StatisticTable
                    :footColumns="differenceFootColumnsWeb"
                    :headColumns="headColumnsLstWeb"
                    :isFlypostModal="true"
                    :rows="rows_difference_web_aprove"
                    :copy-icon="'webmaster'"
                    @copy="copyWebmasters(rows_difference_web_aprove)"
                    title="Вебмастера имеющие -% по апрувам"
                    id="table_difference_web_aprove"
                    class="table_difference_web table_difference_web_aprove noActive"
            >
            </StatisticTable>
        </div>
        <div v-if="isCopyNotify" class="copy-notify">
          {{ $t('pages.webmasters_notify') }}
        </div>
    </div>
</template>

<script>
  import Filters from '@/components/Filters.vue'
  import WebTabs from '../WebTabs'
  import StatisticTable from '../../../components/StatisticTable'
  import API from '../../../api/API'
  import {map} from 'lodash'
  import Helper from '../../../api/Helper'
  import Storage from '../../../api/Storage'
  import FileSaver from 'file-saver'
  import getSymbolFromCurrency from 'currency-symbol-map'

export default {
    components: {
      Filters,
      WebTabs,
      StatisticTable,
      Helper
    },
    data () {
      return {
        isLoading: false,
        isActive: false,
        picked: 'aprove',
        isCopyNotify: false,
        filtersScope: {
          dateFilter: true,
          dateFilterSecond: true,
          offerFilter: true,
          byManualFilter: true
        },
        rows_first: [],
        rows_second: [],
        rows_difference: [],
        rows_last: [],
        rows_difference_web: [],
        rows_difference_aprove: [],
        rows_difference_web_aprove: [],
        firstFootColumns: {},
        differenceFootColumnsWeb: {},
        secondFootColumns: {},
        differenceFootColumns: {},
        lastFootColumns: {},
        headColumns: [
          {label: this.$root.$t('statistic.webmaster'), field: 'webmaster', width: '120px'},
          {label: this.$root.$t('statistic.proportion'), field: 'proportion'},
          {label: this.$root.$t('statistic.total'), field: 'total'},
          {label: this.$root.$t('statistic.accepted'), field: 'accepted', colspan: 2},
          {label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2},
          {label: this.$root.$t('statistic.error'), field: 'error', colspan: 2, isActive: true},
          {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2, isActive: true},
          {label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2, isActive: false},
          {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2, isActive: false}
        ],
        headColumnsDifference: [
          {label: this.$root.$t('statistic.difference'), field: 'difference'}
        ],
        headColumnsLst: [
          {label: this.$root.$t('statistic.webmaster'), field: 'webmaster', width: '120px'},
          {label: this.$root.$t('statistic.proportion'), field: 'proportion'},
          {label: this.$root.$t('statistic.total'), field: 'total'}
        ],
        headColumnsLstWeb: [
          {label: this.$root.$t('statistic.webmaster'), field: 'webmaster', width: '120px'},
          {label: this.$root.$t('statistic.difference'), field: 'difference'}
        ],
        selectTask: '',
        percent: 0,
        x: 0
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      onSwipe (e) {
        const offset = document.getElementById('swipe').offsetWidth
        const scroll = document.getElementById('swipe').scrollWidth
        const width = scroll - offset
        if (width > 0) {
          if (e.deltaX >= 0) {
            this.x += e.distance / 10
          } else {
            this.x -= e.distance / 10
          }
          if (this.x > 0) {
            this.x = 0
          }
          if (Math.abs(this.x) > width) {
            this.x = -width
          }
        }
      },
      getPercent () {
        this.rows_first.forEach(item => {
          if (parseFloat(this.percent) > parseFloat(item.paidPercents.value.replace(',', '.'))) {
            item.webmaster.percentBg = true
          } else {
            item.webmaster.percentBg = false
          }
        })
        this.rows_second.forEach(item => {
          if (item.paidPercents.value && (parseFloat(this.percent) > parseFloat(item.paidPercents.value.replace(',', '.')))) {
            item.webmaster.percentBg = true
          } else {
            item.webmaster.percentBg = false
          }
        })
      },
      reverseColumnsIsActive (items) {
        items.forEach(item => {
          if (item.isActive === true) {
            item.isActive = false
          } else if (item.isActive === false) {
            item.isActive = true
          }
        })
      },
      reverseRowsIsActive (items) {
        items.forEach(item => {
          for (let i in item) {
            if (item[i].isActive === true) {
              item[i].isActive = false
            } else if (item[i].isActive === false) {
              item[i].isActive = true
            }
          }
        })
      },
      reverseFootIsActive (items) {
        for (let i in items) {
          if (items[i].isActive === true) {
            items[i].isActive = false
          } else if (items[i].isActive === false) {
            items[i].isActive = true
          }
        }
      },
      reverseTableActive () {
        let tableAprove = document.querySelector('.table_difference')
        let tablePaid = document.querySelector('.table_difference_aprove')
        if (!tableAprove.classList.contains('noActive')) {
          tableAprove.classList.add('noActive')
          tablePaid.classList.remove('noActive')
        } else {
          tableAprove.classList.remove('noActive')
          tablePaid.classList.add('noActive')
        }
        let tableWeb = document.querySelector('.table_difference_web')
        let tableWebAprove = document.querySelector('.table_difference_web_aprove')
        if (!tableWeb.classList.contains('noActive')) {
          tableWeb.classList.add('noActive')
          tableWebAprove.classList.remove('noActive')
        } else {
          tableWeb.classList.remove('noActive')
          tableWebAprove.classList.add('noActive')
        }
      },
      onChancgeSelect () {
        this.reverseRowsIsActive(this.rows_first)
        this.reverseColumnsIsActive(this.headColumns)
        this.reverseFootIsActive(this.firstFootColumns)
        this.reverseRowsIsActive(this.rows_second)
        this.reverseFootIsActive(this.secondFootColumns)
        this.reverseTableActive()
      },
      sortRows (arr, unsortArr, lastArr) {
        let firstPeriod = []
        let secondPeriod = []
        let lastPeriod = []
        const existsValues = []
        const existsValuesSecond = []
        arr.sort(function (a, b) {
          if (parseInt(a.total_percent) > parseInt(b.total_percent)) {
            return -1
          } else {
            return 1
          }
        })
        for (let val in arr) {
          if (arr[val].total_percent >= 1) {
            firstPeriod.push(arr[val])
          }
          if (arr[val].total_percent >= 1) {
            let arrValue = arr[val]
            existsValues.push(arrValue['wm_id'])
            let toPush = []
            for (let unsortVal in unsortArr) {
              if (!unsortArr.hasOwnProperty(unsortVal)) {
                continue
              }
              let unsortValue = unsortArr[unsortVal]
              if (unsortValue['wm_id'] === arrValue['wm_id']) {
                if (unsortValue.total_percent >= 1) {
                  toPush = unsortValue
                  break
                }
              }
            }
            secondPeriod.push(toPush)
          }
        }
        for (let val in unsortArr) {
          if (!arr.hasOwnProperty(val)) {
            continue
          }
          if (unsortArr[val].total_percent > 1) {
            let unsortValue = unsortArr[val]
            if (existsValues.indexOf(unsortValue['wm_id']) === -1) {
              firstPeriod.push({})
              secondPeriod.push(unsortValue)
            }
          }
        }
        let secondPeriod2 = []
        for (let val in secondPeriod) {
          let arrValue = secondPeriod[val]
          existsValuesSecond.push(arrValue['wm_id'])
          let toPush = []
          for (let unsortVal in lastArr) {
            if (!lastArr.hasOwnProperty(unsortVal)) {
              continue
            }
            if (lastArr[unsortVal].total_percent >= 1) {
              let unsortValue = lastArr[unsortVal]
              if (unsortValue['wm_id'] === arrValue['wm_id']) {
                if (unsortValue.total_percent >= 1) {
                  toPush = unsortValue
                  break
                }
              }
            }
          }
          secondPeriod2.push(secondPeriod[val])
          lastPeriod.push(toPush)
        }
        for (let val in lastArr) {
          if (!secondPeriod2.hasOwnProperty(val)) {
            continue
          }
          if (lastArr[val].total_percent >= 1) {
            let lastValue = lastArr[val]
            if (existsValuesSecond.indexOf(lastValue['wm_id']) === -1) {
              secondPeriod2.push({})
              lastPeriod.push(lastValue)
            }
          }
        }

        return [firstPeriod, secondPeriod, lastPeriod]
      },
      calculateRows () {
        if (this.picked === 'buyout') {
          this.reverseColumnsIsActive(this.headColumns)
          this.picked = 'aprove'
        }
        document.querySelector('.table_difference_aprove').classList.add('noActive')
        document.querySelector('.table_difference').classList.remove('noActive')
        document.querySelector('.table_difference_web').classList.remove('noActive')
        document.querySelector('.table_difference_web_aprove').classList.add('noActive')
        this.$root.$emit('data_loading')
        this.rows_first = []
        this.rows_second = []
        this.rows_difference = []
        this.rows_difference_aprove = []
        this.rows_difference_web = []
        this.rows_difference_web_aprove = []
        this.rows_last = []
        this.firstFootColumns = {}
        this.secondFootColumns = {}
        this.lastFootColumns = {}
        let firstPeriod = []
        let secondPeriod = []
        let lastPeriod = []
        let oldArrCurrency = []
        let newArrCurrency = []
        API.getWebAnalysis().then(response => {
          [firstPeriod, secondPeriod, lastPeriod] = this.sortRows(response.data.first_period, response.data.second_period, response.data.last_week)
          let firstSumTotal = 0
          let firstCountApproved = 0
          let firstSumCanceled = 0
          let firstCountCanceled = 0
          let firstSumPaid = 0
          let firstCountPaid = 0
          let firstSumReturn = 0
          let firstCountReturn = 0
          let firstSumError = 0
          let firstCountError = 0
          let firstSumAverageBill = 0.0
          let firstSumAverageBillLocal = 0.0
          let firstSumApproved = 0
          map(response.data.first_period, d => {
            oldArrCurrency.push(d.local_currency.split(','))
            oldArrCurrency.forEach(array => {
              array.forEach(item => {
                newArrCurrency.push(item)
              })
            })
          })
          let filterCurrency = newArrCurrency.filter((item, index) => {
            return newArrCurrency.indexOf(item) === index
          })
          map(response.data.first_period, (data) => {
            if (data.total > 0) {
              firstSumTotal += parseInt(data.total)
            }
            if (data.approved > 0) {
              firstSumApproved += parseInt(data.approved)
              firstSumApproved = firstSumApproved++
              firstSumAverageBillLocal += data.average_bill_local * data.approved
              firstSumAverageBill += data.average_bill_usd * data.approved
              this.localCurrencySymbol = getSymbolFromCurrency(data.local_currency)
            }
            if (data.canceled > 0) {
              firstSumCanceled += parseInt(data.canceled)
              firstCountCanceled++
            }
            if (data.paid > 0) {
              firstSumPaid += parseInt(data.paid)
              firstCountPaid++
            }
            if (data.return > 0) {
              firstSumReturn += parseInt(data.return)
              firstCountReturn++
            }
            if (data.error > 0) {
              firstSumError += parseInt(data.error)
              firstCountError++
            }
          })
          map(firstPeriod, (data) => {
            this.rows_first.push({
              webmaster: {
                value: data.wm_id,
                percentBg: false
              },
              proportion: {
                value: data.total ? Helper.percents(firstSumTotal, data.total) : ''
              },
              total: {
                value: data.total
              },
              accepted: {
                value: data.approved,
                bgg: Helper.renderGistPart(data.total, data.approved),
                isCollspaned: true
              },
              acceptedPercents: {
                value: data.total && data.approved ? Helper.percents(data.total, data.approved) : '',
                bgg: Helper.renderGistPart(data.total, data.approved, true)
              },
              canceled: {
                value: data.canceled ? data.canceled : '',
                bgg: Helper.renderGistPart(data.total, data.canceled),
                isCollspaned: true
              },
              canceledPercents: {
                value: data.total && data.canceled ? Helper.percents(parseInt(data.total), parseInt(data.canceled)) : '',
                bgg: Helper.renderGistPart(data.total, data.canceled, true)
              },
              error: {
                value: data.error ? data.error : '',
                bgg: Helper.renderGistPart(data.total, data.error),
                isCollspaned: true,
                isActive: true
              },
              errorPercents: {
                value: data.total && data.error ? Helper.percents(parseInt(data.total), parseInt(data.error)) : '',
                bgg: Helper.renderGistPart(data.total, data.error, true),
                isActive: true
              },
              averageBill: {
                value: data.average_bill_usd ? '$ ' + data.average_bill_usd.toFixed(2) : '-',
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(data.average_bill, nch, true)),
                isCollspaned: true,
                isActive: true
              },
              averageBillLocal: {
                  // value: data.average_bill ? Helper.localAverageBill(data.average_bill) : '',
                value: data.local_currency && data.local_currency.split(',').length === 1 ? `${data.average_bill_local.toFixed(0)} ${getSymbolFromCurrency(data.local_currency)}` : '-',
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(data.average_bill, nch, true), true),
                isActive: true
              },
              paid: {
                value: data.paid ? data.paid : '',
                bgg: Helper.renderGistPart(data.approved, data.paid),
                isCollspaned: true,
                isActive: false
              },
              paidPercents: {
                value: data.approved && data.paid ? Helper.percents(parseInt(data.approved), parseInt(data.paid)) : '',
                bgg: Helper.renderGistPart(data.approved, data.paid, true),
                webGraph: true,
                wb: data.wm_id,
                webGraphSymbol: '%',
                isActive: false
              },
              return: {
                value: data.return ? data.return : '',
                bgg: Helper.renderGistPart(data.approved, data.return),
                isCollspaned: true,
                isActive: false
              },
              returnPercents: {
                value: data.approved && data.return ? Helper.percents(parseInt(data.approved), parseInt(data.return)) : '',
                bgg: Helper.renderGistPart(data.approved, data.return, true),
                isActive: false
              }
            })
          })
          this.firstFootColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            proportion: {
              value: null
            },
            total: {
              value: `${firstSumTotal}`
            },
            accepted: {
              value: `${firstSumApproved}`
            },
            acceptedPercents: {
              value: Helper.percents(firstSumTotal, firstSumApproved)
            },
            canceled: {
              value: `${firstSumCanceled}`
            },
            canceledPercents: {
              value: Helper.percents(firstSumTotal, firstSumCanceled)
            },
            error: {
              value: `${firstSumError}`,
              isActive: true
            },
            errorPercents: {
              value: Helper.percents(firstSumTotal, firstSumError),
              isActive: true
            },
            averageBill: {
              value: Helper.averageBillDayCount(firstSumAverageBill, firstSumApproved),
              isActive: true
            },
            averageBillLocal: {
              value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(firstSumAverageBillLocal, firstSumApproved, this.localCurrencySymbol) : '-',
              isActive: true
            },
            paid: {
              value: `${firstSumPaid}`,
              isActive: false
            },
            paidPercents: {
              value: Helper.percents(firstSumApproved, firstSumPaid),
              isActive: false
            },
            return: {
              value: `${firstSumReturn}`,
              isActive: false
            },
            returnPercents: {
              value: Helper.percents(firstSumApproved, firstSumReturn),
              isActive: false
            }
          }
            // SecondPeriod
            // SecondPeriod
            // SecondPeriod
            // SecondPeriod
            // SecondPeriod
            // SecondPeriod
          let secondSumTotal = 0
          let secondCountApproved = 0
          let secondSumProcessed = 0
          let secondCountProcessed = 0
          let secondSumCanceled = 0
          let secondCountCanceled = 0
          let secondSumPaid = 0
          let secondCountPaid = 0
          let secondSumReturn = 0
          let secondCountReturn = 0
          let secondSumError = 0
          let secondCountError = 0
          let secondSumAverageBill = 0.0
          let secondSumAverageBillLocal = 0.0
          let secondSumApproved = 0
          let lastSumTotalBill = 0
          map(response.data.second_period, (data) => {
            if (data.total > 0) {
              secondSumTotal += parseInt(data.total)
            }
            if (data.approved > 0) {
              secondSumProcessed += parseInt(data.approved)
              secondCountProcessed = secondCountProcessed++
            }
            if (data.canceled > 0) {
              secondSumCanceled += parseInt(data.canceled)
              secondCountCanceled++
            }
            if (data.paid > 0) {
              secondSumPaid += parseInt(data.paid)
              secondCountPaid++
            }
            if (data.return > 0) {
              secondSumReturn += parseInt(data.return)
              secondCountReturn++
            }
            if (data.error > 0) {
              secondSumError += parseInt(data.error)
              secondCountError++
            }
            if (data.approved > 0) {
              secondSumApproved += parseInt(data.approved)
              secondCountApproved++
              secondSumAverageBillLocal += parseFloat(data.average_bill_local) * data.approved
              secondSumAverageBill += parseFloat(data.average_bill_usd) * data.approved
              this.localCurrencySymbol = getSymbolFromCurrency(data.local_currency)
            }
          })
          map(secondPeriod, (data) => {
            this.rows_second.push({
              webmaster: {
                value: data.wm_id,
                percentBg: false
              },
              proportion: {
                value: data.total ? Helper.percents(secondSumTotal, data.total) : null
              },
              total: {
                value: data.total
              },
              accepted: {
                value: data.approved ? data.approved : '',
                bgg: Helper.renderGistPart(data.total, data.approved),
                isCollspaned: true
              },
              acceptedPercents: {
                value: data.total && data.approved ? Helper.percents(data.total, data.approved) : null,
                bgg: Helper.renderGistPart(data.total, data.approved, true)
              },
              canceled: {
                value: data.canceled ? data.canceled : '',
                bgg: Helper.renderGistPart(data.total, data.canceled),
                isCollspaned: true
              },
              canceledPercents: {
                value: data.total && data.canceled ? Helper.percents(parseInt(data.total), parseInt(data.canceled)) : null,
                bgg: Helper.renderGistPart(data.total, data.canceled, true)
              },
              error: {
                value: data.error ? data.error : '',
                bgg: Helper.renderGistPart(data.total, data.error),
                isCollspaned: true,
                isActive: true
              },
              errorPercents: {
                value: data.total && data.error ? Helper.percents(parseInt(data.total), parseInt(data.error)) : null,
                bgg: Helper.renderGistPart(data.total, data.error, true),
                isActive: true
              },
              averageBill: {
                value: data.average_bill_usd ? '$ ' + data.average_bill_usd.toFixed(2) : '-',
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(data.average_bill, nch, true)),
                isCollspaned: true,
                isActive: true
              },
              averageBillLocal: {
                value: data.local_currency && data.local_currency.split(',').length === 1 ? `${data.average_bill_local.toFixed(0)} ${getSymbolFromCurrency(data.local_currency)}` : '-',
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(data.average_bill, nch, true), true),
                isActive: true
              },
              paid: {
                value: data.paid ? data.paid : '',
                bgg: Helper.renderGistPart(data.approved, data.paid),
                isCollspaned: true,
                isActive: false
              },
              paidPercents: {
                value: data.approved && data.paid ? Helper.percents(parseInt(data.approved), parseInt(data.paid)) : null,
                bgg: Helper.renderGistPart(data.approved, data.paid, true),
                webGraph: true,
                wb: data.wm_id,
                webGraphSymbol: '%',
                isActive: false
              },
              return: {
                value: data.return ? data.return : '',
                bgg: Helper.renderGistPart(data.approved, data.return),
                isCollspaned: true,
                isActive: false
              },
              returnPercents: {
                value: data.approved && data.return ? Helper.percents(parseInt(data.approved), parseInt(data.return)) : null,
                bgg: Helper.renderGistPart(data.approved, data.return, true),
                isActive: false
              }
            })
          })
          this.secondFootColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            proportion: {
              value: null
            },
            total: {
              value: `${secondSumTotal}`
            },
            accepted: {
              value: `${secondSumProcessed}`
            },
            acceptedPercents: {
              value: Helper.percents(secondSumTotal, secondSumProcessed)
            },
            canceled: {
              value: `${secondSumCanceled}`
            },
            canceledPercents: {
              value: Helper.percents(secondSumTotal, secondSumCanceled)
            },
            error: {
              value: `${secondSumError}`,
              isActive: true
            },
            errorPercents: {
              value: Helper.percents(secondSumTotal, secondSumError),
              isActive: true
            },
            averageBill: {
              value: Helper.averageBillDayCount(secondSumAverageBill, secondSumApproved),
              isActive: true
            },
            averageBillLocal: {
              value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(secondSumAverageBillLocal, secondSumApproved, this.localCurrencySymbol) : '-',
              isActive: true
            },
            paid: {
              value: `${secondSumPaid}`,
              isActive: false
            },
            paidPercents: {
              value: Helper.percents(secondSumProcessed, secondSumPaid),
              isActive: false
            },
            return: {
              value: `${secondSumReturn}`,
              isActive: false
            },
            returnPercents: {
              value: Helper.percents(secondSumProcessed, secondSumReturn),
              isActive: false
            }
          }
            // Defference
            // Defference
            // Defference
            // Defference
            // Defference
            // Defference
          let value1 = map(this.rows_first, (item) => {
            for (let val in item.paidPercents) {
              return parseFloat(item.paidPercents[val].replace(',', '.'))
            }
          })
          let value2 = map(this.rows_second, (item) => {
            for (let val in item.paidPercents) {
              if (item.paidPercents[val]) {
                return parseFloat(item.paidPercents[val].replace(',', '.'))
              } else {
                return null
              }
            }
          })
          let result = []
          const Difference = (val1, val2, wm) => {
            for (let i = 0; i < val2.length; i++) {
              if (val2[i]) {
                result.push({
                  value: val2[i] && val1[i] ? val2[i] - val1[i] : '',
                  webmaster: wm[i].wm_id
                })
              } else {
                result.push({
                  value: val1[i] ? val1[i] : '',
                  webmaster: wm[i].wm_id
                })
              }
            }
          }
          Difference(value1, value2, secondPeriod)
          map(result, (item) => {
            this.rows_difference.push({
              difference: {
                value: item.value ? item.value.toFixed(2) + '%' : item.value,
                minusBg: item.value < 0
              }
            })
            if (item.value < 0) {
              this.rows_difference_web.push({
                webmaster: {
                  value: item.webmaster
                },
                difference: {
                  value: item.value ? item.value.toFixed(2) + '%' : item.value,
                  minusBg: true
                }
              })
            }
          })
            // Defference Aprove
            // Defference Aprove
            // Defference Aprove
            // Defference Aprove
            // Defference Aprove
            // Defference Aprove
          let valueAprove1 = map(this.rows_first, (item) => {
            for (let val in item.acceptedPercents) {
              return parseFloat(item.acceptedPercents[val].replace(',', '.'))
            }
          })
          let valueAprove2 = map(this.rows_second, (item) => {
            for (let val in item.acceptedPercents) {
              if (item.acceptedPercents[val]) {
                return parseFloat(item.acceptedPercents[val].replace(',', '.'))
              }
            }
          })
          let resultAprove = []
          const DefferenceAprove = (val1, val2, wm) => {
            for (let i = 0; i < val2.length; i++) {
              if (val2[i]) {
                resultAprove.push({
                  value: val2[i] && val1[i] ? val2[i] - val1[i] : '',
                  webmaster: wm[i].wm_id
                })
              } else {
                resultAprove.push({
                  value: val1[i] ? val1[i] : '',
                  webmaster: wm[i].wm_id
                })
              }
            }
          }
          DefferenceAprove(valueAprove1, valueAprove2, secondPeriod)
          map(resultAprove, (item) => {
            this.rows_difference_aprove.push({
              difference: {
                value: item.value ? item.value.toFixed(2) + '%' : item.value,
                minusBg: item.value < 0
              }
            })
            if (item.value < 0) {
              this.rows_difference_web_aprove.push({
                webmaster: {
                  value: item.webmaster
                },
                difference: {
                  value: item.value ? item.value.toFixed(2) + '%' : item.value,
                  minusBg: true
                }
              })
            }
          })
            // LastPeriod
            // LastPeriod
            // LastPeriod
            // LastPeriod
            // LastPeriod
          map(response.data.last_week, (data) => {
            if (data.total > 0) {
              lastSumTotalBill += parseInt(data.total)
            }
          })
          map(lastPeriod, (data) => {
            this.rows_last.push({
              webmaster: {
                value: data.wm_id ? data.wm_id : ''
              },
              proportion: {
                value: data.total ? Helper.percents(lastSumTotalBill, data.total) : null
              },
              total: {
                value: data.total ? data.total : ''
              }
            })
          })
          this.$root.$emit('data_loaded')
        })
      },
      exportingAll () {
        const classes = document.getElementsByClassName('excel')
        let doc = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>`
        map(classes, (cl, i) => {
          doc += `${cl.innerHTML}<br/>`
        })
        doc += '</body></html>'
        FileSaver.saveAs(new Blob([doc], {
          encoding: 'UTF-8',
          type: 'application/octet-stream'
        }), `analytics-analysis.xls`)
      },

      copyWebmasters (dataArr) {
        const values = dataArr.map(obj => obj.webmaster.value).filter(Boolean).join(', ')

        navigator.clipboard.writeText(values).then(() => {
          this.isCopyNotify = true

          setTimeout(() => {
            this.isCopyNotify = false
          }, 3000)
        })
      }
    }
  }
</script>

<style>
    .webAnalysis .container__table {
        display: flex;
        overflow-x: scroll;
    }
    .webAnalysis filters__atalytics {
        margin-bottom: 20px;
        width: 100%;
    }
    .webAnalysis .filters__atalytics--content {
        background-color: #fff;
        padding: 10px;
        display: flex;
    }
    .webAnalysis .statistic-wrap {
        margin-right: 20px;
    }
    .webAnalysis tr {
        height: 46px;
    }
    .webAnalysis .th-action {
        white-space: nowrap!important;
    }
    .webAnalysis td{
        white-space: nowrap!important;
    }
    #table_difference .card-actions{
        display: none;
    }
    .webAnalysis .sub {
        background: linear-gradient(to right, rgb(239, 154, 154) 100%, transparent 0%);
    }
    .webAnalysis .percentBg {
        background-color: rgb(255, 128, 1);
    }
    #percent {
        padding: 0px 10px;
        color: #35495e;
    }
    .content__percent {
        margin-left: 40px;
    }
    #table_difference_aprove .card-actions{
        display: none;
    }
    .webAnalysis .card-header {
        white-space: nowrap;
    }
    .content__table_difference_web {
        width: 100%;
        display: flex;
        margin-top: 20px;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .content__table_difference_web .card-actions{
        display: none;
    }
    .table_difference_web {
        width: 30%;
    }
    .webAnalysis .minusBg {
        background-color: rgb(239, 154, 154);
    }

    .copy-notify {
      position: fixed;
      bottom: 0;
      background-color: #000;
      color: #fff;
      padding: 20px;
    }

</style>



// WEBPACK FOOTER //
// WebAnalysis.vue?29c45978